import * as React from 'react'
import { Icon, IconProps, Tooltip } from '@design/pt-ui'

import { CreativeEvent } from '../../interfaces/entities/creative'

interface IHistoryTagProps {
  title: string
  events: CreativeEvent[]
  icon: string
  iconColor?: IconProps['color']
}

function HistoryTag(props: IHistoryTagProps) {
  const { iconColor, events, title, icon } = props

  return events.length === 0 ? null : (
    <Tooltip
      title={
        <div>
          {title}
          <p />

          {events.map((h, i) => {
            return (
              <p style={{ marginBottom: 0, marginTop: 0 }} key={i}>
                {`${h.time.format('DD MM YYYY, HH:mm:ss')} ${h.user}
                  \r\n`}
              </p>
            )
          })}
        </div>
      }
      placement="top">
      <Icon sx={{ marginLeft: '10px' }} color={iconColor}>
        {icon}
      </Icon>
    </Tooltip>
  )
}

export default HistoryTag
